// extracted by mini-css-extract-plugin
export default {"container":"YouTubeMedia-container-b91e032a2fc14bc2153592a9e154bb8f"};